<template>
    <Dialog
        :breakpoints="{ '768px': '96vw' }"
        :style="{ width: '600px' }"
        :header="modalTitle"
        class="base-modal"
        v-model:visible="visible"
        modal
        :append-to="appendTo || 'body'"
    >
        <slot name="content" />
    </Dialog>
</template>

<script lang="ts" setup>
import Dialog from 'primevue/dialog'

const visible = defineModel<boolean>('visible')

defineSlots<{
    content: () => void
}>()
defineProps<{
    modalTitle: string
    appendTo?: 'body' | 'self'
}>()
</script>

<style lang="scss">
.base-modal {
    @include screen(md) {
        min-width: 500px;
    }
}
</style>
